/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import PropTypes from 'prop-types';
import ReactSlider from 'react-slider';
import AppChip from '../../shared/components/app-chip/AppChip';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import {
  formatCurrency,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppLink from '../../shared/components/app-link/AppLink';

function OneWayFilters({
  minPrice,
  maxPrice,
  carriers,
  fareTypes,
  selectedFilters,
  onApplyFilter,
  onTimeFormatChange,
  isAmPmFormat,
}) {
  const intl = useIntl();
  const [selectedMinPrice, setSelectedMinPrice] = useState(
    isMobileWidth() && parseInt(selectedFilters.selectedMinPrice, 10) !== 0
      ? selectedFilters.selectedMinPrice
      : minPrice,
  );
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(
    isMobileWidth() && parseInt(selectedFilters.selectedMaxPrice, 10) !== 0
      ? selectedFilters.selectedMaxPrice
      : maxPrice,
  );
  const [selectedStops, setSelectedStops] = useState(
    selectedFilters.selectedStops,
  );
  const [selectedDepartureTimes, setSelectedDepartureTimes] = useState(
    selectedFilters.selectedDepartureTimes,
  );
  const [selectedArraivalTimes, setSelectedArraivalTimes] = useState(
    selectedFilters.selectedArraivalTimes,
  );
  const [selectedCarriers, setSelectedCarriers] = useState(
    selectedFilters.selectedCarriers,
  );
  const [selectedRefundStatus, setSelectedRefundStatus] = useState(
    selectedFilters.selectedRefundStatus,
  );
  const [selectedFlightNumber, setSelectedFlightNumber] = useState(
    selectedFilters.selectedFlightNumber,
  );
  const [selectedEquipment, setSelectedEquipment] = useState(
    selectedFilters.selectedEquipment,
  );
  const [isSameDayArraival, setIsSameDayArraival] = useState(
    selectedFilters.isSameDayArraival,
  );
  const [selectedAmPmFormat, setSelectedAamPmFormat] = useState(isAmPmFormat);
  const [selectedFareTypes, setSelectedFareTypes] = useState(
    selectedFilters.selectedFareTypes,
  );

  const [showPrice, setShowPrice] = useState(true);
  const [showStops, setShowStops] = useState(true);
  const [showFareTypes, setShowFareTypes] = useState(true);
  const [showRefundStatus, setShowRefundStatus] = useState(true);
  const [showDepTimes, setShowDepTimes] = useState(true);
  const [showArrTimes, setShowArrTimes] = useState(true);
  const [showAirlines, setShowAirlines] = useState(true);
  const [showMoreCarriers, setShowMoreCarriers] = useState(false);
  const [showMoreFareTypes, setShowMoreFareTypes] = useState(false);

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  useEffect(() => {
    if (!isMobileWidth()) {
      setSelectedMinPrice(minPrice);
      setSelectedMaxPrice(maxPrice);
    }
  }, [minPrice, maxPrice]);

  useEffect(() => {
    if (!isMobileWidth()) {
      onApplyFilter({
        selectedMinPrice,
        selectedMaxPrice,
        selectedStops,
        selectedDepartureTimes,
        selectedArraivalTimes,
        selectedCarriers,
        selectedRefundStatus,
        selectedFlightNumber,
        selectedEquipment,
        isSameDayArraival,
        selectedFareTypes,
      });
    }
  }, [
    selectedMinPrice,
    selectedMaxPrice,
    selectedStops,
    selectedDepartureTimes,
    selectedArraivalTimes,
    selectedCarriers,
    selectedRefundStatus,
    selectedFlightNumber,
    selectedEquipment,
    isSameDayArraival,
    selectedFareTypes,
  ]);

  const handleChipSelection = (name, value) => {
    let list = [];
    if (name === 'stops') {
      list = [...selectedStops];
    } else if (name === 'departureTime') {
      list = [...selectedDepartureTimes];
    } else if (name === 'arraivalTime') {
      list = [...selectedArraivalTimes];
    } else if (name === 'carrier') {
      list = [...selectedCarriers];
    } else if (name === 'refundStatus') {
      list = [...selectedRefundStatus];
    } else if (name === 'fareType') {
      list = [...selectedFareTypes];
    }
    const index = list.indexOf(value);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(value);
    }
    if (name === 'stops') {
      setSelectedStops(list);
    } else if (name === 'departureTime') {
      setSelectedDepartureTimes(list);
    } else if (name === 'arraivalTime') {
      setSelectedArraivalTimes(list);
    } else if (name === 'carrier') {
      setSelectedCarriers(list);
    } else if (name === 'refundStatus') {
      setSelectedRefundStatus(list);
    } else if (name === 'fareType') {
      setSelectedFareTypes(list);
    }
  };
  const handleSliderChange = (newValues) => {
    setSelectedMinPrice(newValues[0]);
    setSelectedMaxPrice(newValues[1]);
  };
  const handleTimeFormatChange = () => {
    const isAmPm = selectedAmPmFormat;
    setSelectedAamPmFormat((prev) => !prev);
    onTimeFormatChange(!isAmPm);
  };

  const handleClearFilter = () => {
    onApplyFilter({
      selectedMinPrice: minPrice,
      selectedMaxPrice: maxPrice,
      selectedStops: [],
      selectedDepartureTimes: [],
      selectedArraivalTimes: [],
      selectedCarriers: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isSameDayArraival: false,
      selectedFareTypes: [],
    });
  };
  const handleApplyMobileFilter = () => {
    onApplyFilter({
      selectedMinPrice,
      selectedMaxPrice,
      selectedStops,
      selectedDepartureTimes,
      selectedArraivalTimes,
      selectedCarriers,
      selectedRefundStatus,
      selectedFlightNumber,
      selectedEquipment,
      isSameDayArraival,
      selectedFareTypes,
    });
  };
  useEffect(() => {
    const savedFilters = localStorage.getItem('flightFilters');
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);

      setSelectedMinPrice(parsed.selectedMinPrice);
      setSelectedMaxPrice(parsed.selectedMaxPrice);
      setSelectedStops(parsed.selectedStops);
      setSelectedDepartureTimes(parsed.selectedDepartureTimes);
      setSelectedArraivalTimes(parsed.selectedArraivalTimes);
      setSelectedCarriers(parsed.selectedCarriers);
      setSelectedRefundStatus(parsed.selectedRefundStatus);
      setSelectedFlightNumber(parsed.selectedFlightNumber);
      setSelectedEquipment(parsed.selectedEquipment);
      setIsSameDayArraival(parsed.isSameDayArraival);
      setSelectedFareTypes(parsed.selectedFareTypes);
    }
  }, []);

  const handleClearPrice = () => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
    localStorage.removeItem('flightFilters');
  };

  const handleClearStops = () => {
    setSelectedStops([]);
    setSelectedAamPmFormat(false);
    setIsSameDayArraival(false);
    setSelectedRefundStatus([]);
  };

  return (
    <section className="one-way-flight-filters pt-sm-3 pt-0 position-relative pb-sm-0 pb-5 text-uppercase">
      {isMobileWidth() && (
        <div className="d-flex gap-2 position-fixed bottom-0 z-3 white-background-color p-1 w-100">
          <AppButton
            btnText="Apply"
            variant="primary"
            className="flex-1"
            onClick={handleApplyMobileFilter}
          />
          <AppButton
            btnText="clear"
            variant="outlined"
            className="flex-1"
            onClick={handleClearFilter}
          />
        </div>
      )}
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          <FormattedMessage id="search_by_airlines" />
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={() => setSelectedCarriers([])}
            />
            <AppLink
              linkText={
                showAirlines ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowAirlines((prev) => !prev)}
            />
          </div>
        </div>
        {showAirlines && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            {carriers.length > 5 ? (
              <>
                {carriers.slice(0, 5).map((c) => (
                  <AppCheckBox
                    key={c.validatingcarriername}
                    onChange={() =>
                      handleChipSelection('carrier', c.validatingcarriername)
                    }
                    name="carrier"
                    labelClassName="searchByAirlines"
                    id={c.validatingcarriername}
                    labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                    checked={
                      selectedCarriers.indexOf(c.validatingcarriername) > -1
                    }
                  />
                ))}
                {!showMoreCarriers && (
                  <AppLink
                    linkText="Show More"
                    className="fs-12"
                    onClick={() => setShowMoreCarriers(true)}
                  />
                )}
                {showMoreCarriers && (
                  <>
                    {carriers.slice(5, carriers.length).map((c) => (
                      <AppCheckBox
                        key={c.validatingcarriername}
                        onChange={() =>
                          handleChipSelection(
                            'carrier',
                            c.validatingcarriername,
                          )
                        }
                        name="carrier"
                        labelClassName="searchByAirlines"
                        id={c.validatingcarriername}
                        labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                        checked={
                          selectedCarriers.indexOf(c.validatingcarriername) > -1
                        }
                      />
                    ))}
                    <AppLink
                      linkText="Show Less"
                      className="fs-12"
                      onClick={() => setShowMoreCarriers(false)}
                    />
                  </>
                )}
              </>
            ) : (
              carriers.map((c) => (
                <AppCheckBox
                  key={c.validatingcarriername}
                  onChange={() =>
                    handleChipSelection('carrier', c.validatingcarriername)
                  }
                  name="carrier"
                  labelClassName="searchByAirlines"
                  id={c.validatingcarriername}
                  labelText={`${c.validatingcarriername} (${c.validatingcarrier})`}
                  checked={
                    selectedCarriers.indexOf(c.validatingcarriername) > -1
                  }
                />
              ))
            )}
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          <FormattedMessage id="price_range" />
          <div className="fw-500 d-flex gap-2 align-items-center">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={handleClearPrice}
            />
            <AppLink
              linkText={
                showPrice ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowPrice((prev) => !prev)}
            />
          </div>
        </div>
        {showPrice && (
          <>
            <div>
              <span className="fs-12">
                {formatCurrency(selectedMinPrice)}-
                {formatCurrency(selectedMaxPrice)}
              </span>
            </div>
            <div className="my-3">
              <ReactSlider
                min={Math.floor(minPrice)}
                max={Math.round(maxPrice)}
                value={[selectedMinPrice, selectedMaxPrice]}
                onChange={handleSliderChange}
              />
            </div>
          </>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center ">
          <FormattedMessage id="fare_policy_and_num_stops" />
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={handleClearStops}
            />
            <AppLink
              linkText={
                showStops ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowStops((prev) => !prev)}
            />
          </div>
        </div>
        {showStops && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            <AppCheckBox
              onChange={() => handleChipSelection('stops', '0')}
              name="stops"
              id="0"
              labelText={formattedMessage('non_stop')}
              checked={selectedStops.indexOf('0') > -1}
              radioClassName="nonStopFilter"
            />
            <AppCheckBox
              onChange={() => handleChipSelection('stops', '1')}
              name="stops"
              id="1"
              labelText={formattedMessage('one_stop')}
              checked={selectedStops.indexOf('1') > -1}
              radioClassName="oneStopFilter"
            />
            <AppCheckBox
              onChange={() => handleChipSelection('stops', '2')}
              name="stops"
              id="2"
              labelText="2 stops"
              checked={selectedStops.indexOf('2') > -1}
              radioClassName="twoStopFilter"
            />
            <AppCheckBox
              onChange={() => setIsSameDayArraival((prev) => !prev)}
              name="isSameDayArraival"
              id="isSameDayArraival"
              labelText={formattedMessage('same_day_arraival')}
              checked={isSameDayArraival}
            />
            <AppCheckBox
              onChange={handleTimeFormatChange}
              name="amPmFormat"
              id="amPmFormat"
              labelText={formattedMessage('am_pm_format')}
              checked={selectedAmPmFormat === true}
            />
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          Search By Fare types
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={() => setSelectedFareTypes([])}
            />
            <AppLink
              linkText={
                showFareTypes ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowFareTypes((prev) => !prev)}
            />
          </div>
        </div>

        {showFareTypes && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            {fareTypes.length > 5 ? (
              <>
                {fareTypes.slice(0, 5).map((fare) => (
                  <AppCheckBox
                    key={fare}
                    onChange={() => handleChipSelection('fareType', fare)}
                    name="fareType"
                    id={fare}
                    labelText={fare}
                    checked={selectedFareTypes.indexOf(fare) > -1}
                  />
                ))}
                {!showMoreFareTypes && (
                  <AppLink
                    linkText="Show More"
                    className="fs-12"
                    onClick={() => setShowMoreFareTypes(true)}
                  />
                )}
                {showMoreFareTypes && (
                  <>
                    {fareTypes.slice(5, fareTypes.length).map((fare) => (
                      <AppCheckBox
                        key={fare}
                        onChange={() => handleChipSelection('fareType', fare)}
                        name="fareType"
                        id={fare}
                        labelText={fare}
                        checked={selectedFareTypes.indexOf(fare) > -1}
                      />
                    ))}
                    <AppLink
                      linkText="Show Less"
                      className="fs-12"
                      onClick={() => setShowMoreFareTypes(false)}
                    />
                  </>
                )}
              </>
            ) : (
              fareTypes.map((fare) => (
                <AppCheckBox
                  key={fare}
                  onChange={() => handleChipSelection('fareType', fare)}
                  name="fareType"
                  id={fare}
                  labelText={fare}
                  checked={selectedFareTypes.indexOf(fare) > -1}
                />
              ))
            )}
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header d-flex justify-content-between align-items-center">
          Refundable Info
          <div className="d-flex gap-2 align-items-center fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={() => setSelectedRefundStatus([])}
            />
            <AppLink
              linkText={
                showRefundStatus ? (
                  <MdKeyboardArrowUp />
                ) : (
                  <MdKeyboardArrowDown />
                )
              }
              variant="black"
              onClick={() => setShowRefundStatus((prev) => !prev)}
            />
          </div>
        </div>
        {showRefundStatus && (
          <div className="one-way-flight-filters_section_content d-flex flex-column gap-2">
            <AppCheckBox
              onChange={() => handleChipSelection('refundStatus', 'Y')}
              name="refundStatus"
              id="Y"
              labelText={formattedMessage('is_refundable')}
              checked={selectedRefundStatus.indexOf('Y') > -1}
            />
            <AppCheckBox
              onChange={() => handleChipSelection('refundStatus', 'N')}
              name="refundStatus"
              id="N"
              labelText="Non-Refundable"
              checked={selectedRefundStatus.indexOf('N') > -1}
            />
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header mb-2 d-flex justify-content-between align-items-center">
          <FormattedMessage id="depart_time" />
          <div className="d-flex gap-2 align-items-center  fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={() => setSelectedDepartureTimes([])}
            />
            <AppLink
              linkText={
                showDepTimes ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowDepTimes((prev) => !prev)}
            />
          </div>
        </div>
        {showDepTimes && (
          <div className="one-way-flight-filters_section_content">
            <div className="d-flex justify-content-between">
              <AppChip
                selected={selectedDepartureTimes.indexOf('0000-0599') > -1}
                name="departureTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/sunrise.svg" alt="" />
                    <span>00 -06</span>
                  </div>
                }
                value="0000-0599"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
              <AppChip
                selected={selectedDepartureTimes.indexOf('0600-1199') > -1}
                name="departureTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/afternoon_sun.svg" alt="" />
                    <span>06 -12</span>
                  </div>
                }
                value="0600-1199"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
            </div>
            <div className="d-flex justify-content-between">
              <AppChip
                selected={selectedDepartureTimes.indexOf('1200-1799') > -1}
                name="departureTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/evening_time.svg" alt="" />
                    <span>12-18</span>
                  </div>
                }
                value="1200-1799"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
              <AppChip
                selected={selectedDepartureTimes.indexOf('1800-2399') > -1}
                name="departureTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/night_time.svg" alt="" />
                    <span>18-00</span>
                  </div>
                }
                value="1800-2399"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <div className="one-way-flight-filters_section_header mb-2 d-flex justify-content-between align-items-center">
          <FormattedMessage id="arraival_time" />
          <div className="d-flex gap-2 align-items-center  fw-500">
            <AppLink
              linkText="Clear"
              className="fs-12"
              variant="black"
              onClick={() => setSelectedArraivalTimes([])}
            />
            <AppLink
              linkText={
                showArrTimes ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />
              }
              variant="black"
              onClick={() => setShowArrTimes((prev) => !prev)}
            />
          </div>
        </div>

        {showArrTimes && (
          <div className="one-way-flight-filters_section_content">
            <div className="d-flex justify-content-between">
              <AppChip
                selected={selectedArraivalTimes.indexOf('0000-0599') > -1}
                name="arraivalTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/sunrise.svg" alt="" />
                    <span>00 -06</span>
                  </div>
                }
                value="0000-0599"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
              <AppChip
                selected={selectedArraivalTimes.indexOf('0600-1199') > -1}
                name="arraivalTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/afternoon_sun.svg" alt="" />
                    <span>06 -12</span>
                  </div>
                }
                value="0600-1199"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
            </div>
            <div className="d-flex justify-content-between">
              <AppChip
                selected={selectedArraivalTimes.indexOf('1200-1799') > -1}
                name="arraivalTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/evening_time.svg" alt="" />
                    <span>12-18</span>
                  </div>
                }
                value="1200-1799"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
              <AppChip
                selected={selectedArraivalTimes.indexOf('1800-2399') > -1}
                name="arraivalTime"
                chipText={
                  <div className="d-flex gap-1 align-items-center justify-content-center">
                    <img src="/images/others/night_time.svg" alt="" />
                    <span>18-00</span>
                  </div>
                }
                value="1800-2399"
                className="m-1 text-center flex-1"
                onClick={handleChipSelection}
              />
            </div>
          </div>
        )}
      </div>
      <div className="one-way-flight-filters_section">
        <AppTextInput
          label="Filter by Flight Number"
          placeholderText="Eg: QP-571"
          value={selectedFlightNumber}
          onChange={(e) => setSelectedFlightNumber(e.target.value)}
          className="filterByFlightNumber"
        />
      </div>
      <div className="one-way-flight-filters_section">
        <AppTextInput
          label="Filter By Aircraft Type"
          placeholderText="Eg: 380"
          value={selectedEquipment}
          onChange={(e) => setSelectedEquipment(e.target.value)}
        />
      </div>
    </section>
  );
}

OneWayFilters.propTypes = {
  minPrice: PropTypes.number.isRequired,
  maxPrice: PropTypes.number.isRequired,
  carriers: PropTypes.array.isRequired,
  fareTypes: PropTypes.array.isRequired,
  selectedFilters: PropTypes.object.isRequired,
  onApplyFilter: PropTypes.func.isRequired,
  onTimeFormatChange: PropTypes.func.isRequired,
  isAmPmFormat: PropTypes.any.isRequired,
};

export default OneWayFilters;
